module.exports = __webpack_public_path__ + "static/media/microsoftedge.6f8488ff.png";